import {
  ComboboxParsedItem,
  ComboboxParsedItemGroup,
  OptionsFilter,
} from "@mantine/core"

export const SelectStartsWithFilter: OptionsFilter = ({ options, search }) => {
  const lowerSearch = search.toLowerCase()
  return options.filter((item) => {
    if (isGroup(item)) {
      // Filter group if any of its items match
      return item.items.some((i) =>
        i.label.toLowerCase().startsWith(lowerSearch)
      )
    } else {
      // Filter single item
      return item.label.toLowerCase().startsWith(lowerSearch)
    }
  })
}

function isGroup(
  item: ComboboxParsedItem<string>
): item is ComboboxParsedItemGroup<string> {
  return (
    typeof item === "object" && "items" in item && Array.isArray(item.items)
  )
}
